var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.292,
    height: 16,
    viewBox: "0 0 16.292 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "login",
    d: "M411.84,1185.111h-1.121a.161.161,0,0,0-.161.16v1.289H397.44v-13.12h13.12v1.289a.161.161,0,0,0,.161.16h1.121a.16.16,0,0,0,.16-.16v-2.089a.638.638,0,0,0-.639-.64H396.64a.638.638,0,0,0-.64.64v14.72a.638.638,0,0,0,.64.64h14.72a.638.638,0,0,0,.64-.64v-2.089A.161.161,0,0,0,411.84,1185.111Zm.285-5.858h-6.542v-1.582a.167.167,0,0,0-.27-.133l-2.956,2.329a.157.157,0,0,0-.047.062.158.158,0,0,0,0,.142.157.157,0,0,0,.047.062l2.956,2.329a.166.166,0,0,0,.27-.133v-1.582h6.542a.163.163,0,0,0,.166-.16v-1.173A.163.163,0,0,0,412.125,1179.253Z",
    transform: "translate(412.292 1188) rotate(180)",
    fill: "#33af89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.9a65804b5f7dbdf6dea62f62c3e2c46f.svg";
export { ForwardRef as ReactComponent };